import React from 'react';
import { Link } from '../link';
import AppStore from '../../images/appstore.png';
import PlayStore from '../../images/playstore.png';

const StoreIcon = (props) => {
  function getStoreIcon(name) {
    let _name = name;

    switch (_name) {
      case 'Google Play Store':
        return PlayStore;

      case 'Apple App Store':
        return AppStore;

      default:
        break;
    }
  }
  return (
    <Link
      className='footer__download-bar--link'
      to={props.url}
      title={`Cattolica su ${props.name}`}
    >
      <img
        className='footer__download-bar--img'
        src={getStoreIcon(props.name)}
        alt={props.name}
      />
    </Link>
  );
};

export default StoreIcon;
